module.exports = __webpack_public_path__ + "media/images/ac_templates/201/pch-87d08acf01c39a3e55d9613038dc96d1.jpg";